import React from "react";

// Satır içi biçimlendirme:
//   **kalın**      → <strong>
//   ==vurgu==      → <mark>  (fosforlu kalem: sınav için kritik bilgi / sayı)
//   __altı çizili__ → <u>     (anahtar tanım / terim)
// İç içe kullanılabilir: ==**Mısır Piramitleri**==
const TOKEN = /(==[^=]+==|__[^_]+__|\*\*[^*]+\*\*)/g;

function renderInline(str, keyBase) {
  const parts = str.split(TOKEN);
  return parts.map((p, i) => {
    const key = `${keyBase}-${i}`;
    if (!p) return null;
    if (p.startsWith("==") && p.endsWith("==") && p.length > 4) return <mark key={key} className="hl">{renderInline(p.slice(2, -2), key)}</mark>;
    if (p.startsWith("__") && p.endsWith("__") && p.length > 4) return <u key={key} className="ul">{renderInline(p.slice(2, -2), key)}</u>;
    if (p.startsWith("**") && p.endsWith("**") && p.length > 4) return <strong key={key}>{renderInline(p.slice(2, -2), key)}</strong>;
    return <React.Fragment key={key}>{p}</React.Fragment>;
  });
}

export function RichText({ text }) {
  if (text == null) return null;
  const lines = String(text).split("\n");
  return lines.map((line, li) => (
    <React.Fragment key={li}>
      {li > 0 && <br />}
      {renderInline(line, li)}
    </React.Fragment>
  ));
}
